export const GET_IMAGE_EDITOR_FIRMS_SUCCESS = 'GET_IMAGE_EDITOR_FIRMS_SUCCESS';
export const GET_IMAGE_EDITOR_FIRM_SUCCESS = 'GET_IMAGE_EDITOR_FIRM_SUCCESS';

export const SAVE_IMAGE_EDITOR_FIRM_SUCCESS = 'SAVE_IMAGE_EDITOR_FIRM_SUCCESS';
export const UPDATE_IMAGE_EDITOR_FIRM_FORM_SUCCESS = 'UPDATE_IMAGE_EDITOR_FIRM_FORM_SUCCESS';
export const CHANGE_ISDISCONTINUED_IMAGE_EDITOR_FIRM_SUCCESS = 'CHANGE_ISDISCONTINUED_IMAGE_EDITOR_FIRM_SUCCESS';
export const DELETE_IMAGE_EDITOR_FIRM_FAILURE = 'DELETE_IMAGE_EDITOR_FIRM_FAILURE';


